import { render, staticRenderFns } from "./WizardSteps.vue?vue&type=template&id=641c0973"
import script from "./WizardSteps.vue?vue&type=script&lang=js"
export * from "./WizardSteps.vue?vue&type=script&lang=js"
import style0 from "./WizardSteps.vue?vue&type=style&index=0&id=641c0973&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports